import { PayloadAction } from "@reduxjs/toolkit";
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import {
  IApiResponse,
  IErrorResponse,
  IImportPeriodCycleCountByLocation,
  IImportPeriodCycleCountByProduct,
  IImportProductionPlanRequest,
  IPeriodicCycleCountConfirmLocationRequest,
} from "model";
import { call, put, takeEvery } from "redux-saga/effects";
import { CycleCountActions, ProductionPlanActions } from "redux/actions";
import { CycleCountApiService, ProductionPlanApiService } from "services";

function* importPeriodicCycleCountByProduct(
  action: PayloadAction<IImportPeriodCycleCountByProduct>
) {
  try {
    const result: IApiResponse<any> = yield call(
      CycleCountApiService.importPeriodCycleCountByProduct,
      action.payload
    );
    if (result.succeeded) {
      yield put(CycleCountActions.importPeriodicCycleCountByProduct.success());
      AlertHelper.showAlert(
        "Import Cycle Count Successfully",
        EAlertType.SUCCESS
      );
    } else {
      const error = result as IErrorResponse;
      yield put(
        CycleCountActions.importPeriodicCycleCountByProduct.failed(error)
      );
    }
  } catch (error) {
    yield put(
      CycleCountActions.importPeriodicCycleCountByProduct.failed(error)
    );
  }
}

function* importPeriodicCycleCountByLocation(
  action: PayloadAction<IImportPeriodCycleCountByLocation>
) {
  try {
    const result: IApiResponse<any> = yield call(
      CycleCountApiService.importPeriodCycleCountByLocation,
      action.payload
    );
    if (result.succeeded) {
      yield put(CycleCountActions.importPeriodicCycleCountByLocation.success());
      AlertHelper.showAlert(
        "Import Cycle Count Successfully",
        EAlertType.SUCCESS
      );
    } else {
      const error = result as IErrorResponse;
      yield put(
        CycleCountActions.importPeriodicCycleCountByLocation.failed(error)
      );
    }
  } catch (error) {
    yield put(
      CycleCountActions.importPeriodicCycleCountByLocation.failed(error)
    );
  }
}

function* importPeriodicCycleCountConfirmLocation(
  action: PayloadAction<IPeriodicCycleCountConfirmLocationRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      CycleCountApiService.importPeriodicCycleCountConfirmLocation,
      action.payload
    );
    if (result.succeeded) {
      yield put(
        CycleCountActions.importPeriodicCycleCountConfirmLocation.success()
      );
      AlertHelper.showAlert("Cập nhật kiểm kê thành công", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(
        CycleCountActions.importPeriodicCycleCountConfirmLocation.failed(error)
      );
    }
  } catch (error) {
    yield put(
      CycleCountActions.importPeriodicCycleCountConfirmLocation.failed(error)
    );
  }
}

export function* Watcher() {
  yield takeEvery(
    CycleCountActions.importPeriodicCycleCountByProduct.request,
    importPeriodicCycleCountByProduct
  );
  yield takeEvery(
    CycleCountActions.importPeriodicCycleCountByLocation.request,
    importPeriodicCycleCountByLocation
  );
  yield takeEvery(
    CycleCountActions.importPeriodicCycleCountConfirmLocation.request,
    importPeriodicCycleCountConfirmLocation
  );
}
